export function fetchProduct(gid) {
	return fetch(
		process.env.REACT_APP_BASE_API + 'order/apis/getProducts.php?gid=' + gid
	).then((response) => response.json())
}

export function fetchProductsPromo(data) {
	return fetch(
		process.env.REACT_APP_BASE_API + 'order/apis/getProductsPromo.php?gid=' + data.gid + '&pid=' + data.pid + '&billingcycle=' + data.billingcycle + '&promocode=' + data.promocode + '&userid=' + data.userid
	).then((response) => response.json())
}

export function fetchProductByPid(pid) {
	return fetch(
		process.env.REACT_APP_BASE_API + 'order/apis/getProducts.php?pid=' + pid
	).then((response) => response.json())
}
